<!--/* eslint-disable */-->
<template>
  <div>
    <vs-table
      stripe
      :data="balanceTable"
      :title="title"
      noDataText="Não há balanços cadastrados">
      <template slot="thead">

      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(row, indextr) in data">
          <vs-td :key="idx" v-for="(item, idx) in row">
            <template v-if="idx === 0">
              <p class="font-semibold">{{item}}</p>
            </template>
            <template v-else>
              <span>{{item | toDecimal}}</span>
            </template>
          </vs-td>
        </vs-tr>
      </template>

    </vs-table>
  </div>
</template>

<script>

export default {
  name: 'BalancoForm',
  props: {
    balanceDtoTable: Object,
    title: {
      default:'',
      type:[String]
    },
  },
  watch:{
    balanceDtoTable (newVal) {
      if (newVal != null) {
        this.balanceDtoTable = newVal
        this.getBalanceTable()
      }
    }
  },
  data () {
    return {
      balanceTable: []
    }
  },
  methods: {

    getBalanceTable () {
      const balanceObj = Object.entries(this.balanceDtoTable.columns)
      this.balanceTable = []
      for (let i = 0; i < balanceObj.length; i++) {
        const line = []
        //Title
        line.push(balanceObj[i][0])
        //Values
        for (let j = 1; j < balanceObj[i].length; j++) {
          const values = balanceObj[i][j]
          for (let z = 0; z < values.length; z++) {
            line.push(values[z])
          }
        }
        this.balanceTable.push(line)
      }
    }
  }
}

</script>

<style scoped>

</style>
